<template>
    <div>
        <div
            class="row"
            v-if="groupPairGroupIn.feedback"
            style="margin-bottom: 30px">
            <div class="col-md-12">
                <div class="feedback-header">
                    <h5>Feedback:</h5>
                    <b-button
                        class="btn-history btn-show-feedback-history"
                        v-b-tooltip.hover
                        :title="$t('group_pair.show_log')"
                        variant="primary-icon"
                        @click="showHistory()">
                    </b-button>
                </div>
            </div>
            <div class="col-md-12">
                <b-alert
                    variant="warning"
                    show
                    >{{ groupPairGroupIn.feedback }}</b-alert
                >
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <!--                current-->
                <div class="row">
                    <design-2021-group-pair-current-group-component
                        :users-in="participatingUsers"
                        @remove-student="removeStudent($event)"
                        @remove-teacher="removeTeacher($event)"></design-2021-group-pair-current-group-component>
                </div>

                <!--                students-->
                <div
                    class="row"
                    v-if="groupIn.group_pair_options.cooperation_partner === 1"
                    style="margin-top: 30px">
                    <design-2021-group-pair-student-component
                        :group-in="groupIn"
                        :students-in="studentsIn"
                        :selected-students-in="selectedStudents"
                        @add-student="addStudent($event)"
                        :error="studentTotalError"></design-2021-group-pair-student-component>
                </div>

                <!--                teachers-->
                <div
                    class="row"
                    v-if="groupIn.group_pair_options.teacher === 1"
                    style="margin-top: 30px">
                    <design-2021-group-pair-teacher-component
                        :selected-teachers-in="selectedTeachers"
                        :teachers-in="teachersIn"
                        @add-teacher="addTeacher($event)"
                        :required="groupIn.group_pair_options.teacher_option === 1"
                        :teacher-max-forced="groupIn.group_pair_options.teacher_force_max"
                        :check-option="groupIn.group_pair_options.check_option"
                        :max-teachers-in="groupIn.group_pair_options.max_teachers">
                    </design-2021-group-pair-teacher-component>
                </div>
            </div>

            <!--            form-->
            <div class="col-lg-6">
                <design-2021-group-pair-edit-form-component
                    :group-in="groupIn"
                    :courses-in="coursesIn"
                    :group-pair-group-in="groupPairGroupIn"
                    :students-in="selectedStudents"
                    :subject-in="this.groupPairGroupIn.subject"
                    :motivation-in="this.groupPairGroupIn.explanation"
                    :selected-courses-in="this.groupPairGroupIn.courses"
                    :file-in="this.groupPairGroupIn.group_pair_group_file[0]"
                    @create-group="createGroup($event)"></design-2021-group-pair-edit-form-component>
            </div>
        </div>
        <design-2021-group-pair-history-modal-component
            :activities-in="groupPairGroupIn.activities"
            ref="history-log-modal">
        </design-2021-group-pair-history-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-pair-edit-component',
    props: ['userIn', 'groupIn', 'coursesIn', 'studentsIn', 'teachersIn', 'groupPairGroupIn'],
    data() {
        return {
            selectedStudents: this.groupPairGroupIn.group_pair_students.map((student) => {
                let selectedCourses = [];
                if (student.courses.length) {
                    selectedCourses = student.courses; //.map((course) => course.id);
                }

                return {
                    id: student.user.id,
                    name: student.user.full_name,
                    removable: true,
                    selectedCourses: selectedCourses,
                    type: 'Student',
                };
            }),
            selectedTeachers: this.groupPairGroupIn.group_pair_group_teachers.map((teacher) => {
                return {
                    id: teacher.user.id,
                    name: teacher.user.full_name,
                    removable: true,
                    type: 'Docent',
                };
            }),
            studentTotalError: false,
        };
    },
    computed: {
        participatingUsers() {
            let array2 = [...this.selectedStudents, ...this.selectedTeachers];
            array2 = array2.map((user) => {
                if (user.id !== this.userIn.id) {
                    return user;
                }
                return {
                    name: this.userIn.full_name,
                    removable: false,
                    id: this.userIn.id,
                };
            });

            return array2;
        },
    },
    methods: {
        showHistory() {
            this.$refs['history-log-modal'].show();
        },
        addStudent(student) {
            this.selectedStudents.push({
                id: student.user.id,
                name: student.user.full_name,
                removable: true,
                type: 'Student',
            });
        },
        addTeacher(teacher) {
            this.selectedTeachers.push({
                id: teacher.user.id,
                name: teacher.user.full_name,
                removable: true,
                type: 'Docent',
            });
        },
        removeStudent(id) {
            this.selectedStudents = this.selectedStudents.filter((student) => student.id !== id);
        },
        removeTeacher(id) {
            this.selectedTeachers = this.selectedTeachers.filter((teacher) => teacher.id !== id);
        },
        createGroup(data) {
            let error = false;
            if (
                this.groupIn.group_pair_options.teacher &&
                this.groupIn.group_pair_options.teacher_option === 1 &&
                !this.selectedTeachers.length
            ) {
                error = true;
            }
            if (
                this.groupIn.group_pair_options.topic &&
                this.groupIn.group_pair_options.topic_option === 1 &&
                !data.subject
            ) {
                error = true;
            }
            if (
                this.groupIn.group_pair_options.course &&
                this.groupIn.group_pair_options.course_option === 1 &&
                !data.selectedCourses.length
            ) {
                error = true;
            }
            if (
                this.groupIn.group_pair_options.argumentation &&
                this.groupIn.group_pair_options.argumentation_option === 1 &&
                !data.motivation
            ) {
                error = true;
            }
            if (data.course_total_error) {
                error = true;
            }
            if (data.course_personal_error) {
                error = true;
            }
            if (this.studentTotalError) {
                error = true;
            }
            if (data.overSubjectLength > 0) {
                error = true;
            }

            if (error) {
                this.alert.warning(
                    this.$t('group_pair.incomplete_form'),
                    this.$t('group_pair.not_all_exercises_are_filled_in_correctly'),
                );
                return;
            }

            let formData = new FormData();

            for (let i = 0; i < this.selectedStudents.length; i++) {
                formData.append(`students[${i}]`, this.selectedStudents[i].id);
            }
            for (let i = 0; i < this.selectedTeachers.length; i++) {
                formData.append(`teachers[${i}]`, this.selectedTeachers[i].id);
            }
            for (let i = 0; i < data.selectedCourses.length; i++) {
                formData.append(`courses[${i}]`, data.selectedCourses[i].id);
            }
            for (let i = 0; i < data.personalSelectedCourses.length; i++) {
                formData.append(
                    `personalSelectedCourses[${i}]`,
                    JSON.stringify({
                        id: data.personalSelectedCourses[i].id,
                        selectedCourses: data.personalSelectedCourses[i].selectedCourses.map((course) => course.id),
                    }),
                );
            }

            formData.append('group_id', this.groupIn.id);
            if (data.subject) {
                formData.append('subject', data.subject);
            }
            if (data.motivation) {
                formData.append('motivation', data.motivation);
            }
            if (data.file) {
                formData.append('file', data.file);
            }

            const headers = { 'Content-Type': 'multipart/form-data' };

            this.alert.saving();
            this.axios.post(this.routes.groupPairUpdate(this.groupPairGroupIn.id), formData, { headers: headers }).then(
                (response) => {
                    this.alert.success();
                    window.location.href = this.routes.baseUrl();
                },
                (error) => {
                    if (error.response && error.response.data && error.response.data.type) {
                        if (error.response.data.type === 'user_has_group') {
                            this.alert.warning(
                                this.$t('group_pair.already_in_a_group'),
                                this.$t('group_pair.you_seem_to_be_in_a_group_already_maybe_someone_else_added_you'),
                            );
                        } else if (error.response.data.type === 'users_taken') {
                            const title = this.$t('group_pair.selected_students_and_or_teachers_already_chosen');
                            let text = '';
                            if (error.response.data.students_taken.length) {
                                const names = error.response.data.students_taken
                                    .map((student) => student.user.full_name)
                                    .join(', ');
                                text += this.$t('group_pair.the_next_students_are_already_in_a_group') + names + '. ';
                            }
                            if (error.response.data.teachers_taken.length) {
                                const names = error.response.data.teachers_taken
                                    .map((teacher) => teacher.user.full_name)
                                    .join(', ');
                                text += this.$t('group_pair.the_next_students_can_no_longer_be_chosen') + names + '.';
                            }
                            this.alert.warning(title, text);
                            // todo finish
                        } else {
                            this.alert.ajaxError(error);
                        }
                    } else {
                        this.alert.ajaxError(error);
                    }
                },
            );
        },
    },

    watch: {
        selectedStudents: function (value) {
            const min = this.groupIn.group_pair_options.partner_min;
            const max = this.groupIn.group_pair_options.partner_max;

            if (min !== null && max === null) {
                this.studentTotalError = value.length < min;
            } else if (min === null && max !== null) {
                this.studentTotalError = value.length > max;
            } else if (min === null && max === null) {
                this.studentTotalError = false;
            } else if (min === max && value.length !== min) {
                this.studentTotalError = true;
            } else this.studentTotalError = !(value.length >= min && value.length <= max);
        },
    },
};
</script>

<style lang="scss" scoped>
.feedback-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: $grid-gutter-width;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    h5 {
        margin-bottom: 0;
    }
}

.btn-show-feedback-history {
    &:before {
        margin-right: 0;
    }
}
</style>
